/** @format */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

/** Sends a GA4 `page_view` whenever the router location changes. */
export const usePageTracking = (): void => {
	const location = useLocation();

	useEffect(() => {
		trackPageView(location.pathname + location.search);
	}, [location.pathname, location.search]);
};
